import { atom, useAtomValue, useSetAtom } from "jotai";
import type { PostPublishSuccessPropertyViewModel } from "libs/codegen/homes-onbaording";

export const propertyViewModelAtom = atom<PostPublishSuccessPropertyViewModel>({
    publishedListing: null,
    incompleteListings: null,
});

export const usePropertyViewModelValue = () => useAtomValue(propertyViewModelAtom);
export const useSetPropertyViewModel = () => useSetAtom(propertyViewModelAtom);
